




















































import { Component, Vue, Watch } from 'vue-property-decorator';

import TireRegisterInputInfo from '@/components/tire/TireRegisterInputInfo.vue';
import TireRegisterInputImage from '@/components/tire/TireRegisterInputImage.vue';
import TireRegisterInputPaint from '@/components/tire/TireRegisterInputPaint.vue';
import TireConfirmInfo from '@/components/tire/TireConfirmInfo.vue';
import TireConfirmTerm from '@/components/tire/TireConfirmTerm.vue';

import {
  Utils,
  DataBus,
  Customer,
  TireStoringContract,
  TireTypeEnum,
  ResponseCodeEnum,
  TireStoringInfo,
  TireStoringContractSeasonInfo,
} from '@/models';
import { tireStoringContractService, customerService, toastService } from '@/services';

// @ts-ignore
import Loading from 'vue-loading-overlay';

@Component({
  components: {
    TireRegisterInputInfo,
    TireRegisterInputImage,
    TireRegisterInputPaint,
    TireConfirmInfo,
    TireConfirmTerm,
    Loading,
  },
})
export default class TireRegisterPage extends Vue {
  private isLoading: boolean = false;
  private isEdit: boolean = false;
  private isReNew: boolean = false;
  private isSwitch: boolean = false;
  private reNewParam = '';
  private currentCustomer: Customer = new Customer();
  private tireContract: TireStoringContract = new TireStoringContract({
    customer: new Customer(),
    status: 0,
    tireType: null,
    summerSeasonInfo: new TireStoringContractSeasonInfo({
      tireType: TireTypeEnum.SUMMER,
      tires: [
        new TireStoringInfo({ no: 1, type: TireTypeEnum.SUMMER }),
        new TireStoringInfo({ no: 2, type: TireTypeEnum.SUMMER }),
        new TireStoringInfo({ no: 3, type: TireTypeEnum.SUMMER }),
        new TireStoringInfo({ no: 4, type: TireTypeEnum.SUMMER })
      ],
    }),
    winterSeasonInfo: new TireStoringContractSeasonInfo({
      tireType: TireTypeEnum.WINTER,
      tires: [
        new TireStoringInfo({ no: 1, type: TireTypeEnum.WINTER }),
        new TireStoringInfo({ no: 2, type: TireTypeEnum.WINTER }),
        new TireStoringInfo({ no: 3, type: TireTypeEnum.WINTER }),
        new TireStoringInfo({ no: 4, type: TireTypeEnum.WINTER })
      ],
    }),
  });
  private tireContractList: TireStoringContract[] = [];

  private showTireInfoComponent: boolean = false;
  private showTireImageComponent: boolean = false;
  private showTireImageEditComponent: boolean = false;
  private showTireConfirmInfoComponent: boolean = false;
  private showTireConfirmTermComponent: boolean = false;
  private showRegistrationCompletedModal: boolean = false;
  private showSwitchTireDialog: boolean = false;
  private showCancelRegisterDialog: boolean = false;
  private showCancelRegisterMultiDialog: boolean = false;
  private isConfirmMode: boolean = false;

  private created() {
    const customerIdParam = Utils.getQueryParam(this.$route.query.customerId);
    const contractIdParam = Utils.getQueryParam(this.$route.query.contractId);
    const reNewParam = Utils.getQueryParam(this.$route.query.reNew);
    this.reNewParam = Utils.getQueryParam(this.$route.query.reNew);
    const switchParam = Utils.getQueryParam(this.$route.query.switchTire);
    const confirmed = Utils.getQueryParam(this.$route.query.confirmed);
    if (!customerIdParam) {
      this.$router.push({ name: 'routes.home' });
    }
    if (switchParam) {
      this.isSwitch = true;
    }

    // Get customer info
    this.loadCustomerInfo(customerIdParam)
      .then((isSuccess) => {
        if (!isSuccess) {
          this.$router.push({ name: 'routes.home' });
        }

        // Get contract info
        if (contractIdParam) {
          this.loadContractInfo(contractIdParam, reNewParam === 'true')
            .then((isSuccess) => {
              if (isSuccess) {             
                if (confirmed === 'true') {
                  // Confirm mode
                  this.loadTireConfirmInfoComponent(true);
                } else {
                  // Edit mode
                  this.loadTireInfoComponent();
                }
              } else {
                this.$router.push({ name: 'routes.home' });
              }
            });
        } else {
          this.loadTireInfoComponent();
        }
      });
  }

  private loadCustomerInfo(customerId: string): Promise<boolean> {
    return customerService.get(customerId)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.currentCustomer = res.data.data;
          this.tireContract.customer = res.data.data;
          return true;
        }
        return false;
      });
  }

  private loadContractInfo(contractId: string, isReNew: boolean): Promise<boolean> {
    return tireStoringContractService.get(contractId)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          if (isReNew) {
            this.isReNew = true;
            this.isEdit = false;
            this.tireContract = res.data.data;
            if (this.tireContract.summerSeasonInfo) {         
              this.tireContract.summerSeasonInfo.id = undefined;   
              if (this.tireContract.summerSeasonInfo.tires) {
                this.tireContract.summerSeasonInfo.tires.forEach((tire) => {
                  tire.id = undefined;
                  tire.groove = undefined;
                  tire.fileScratch = [];
                });
              }            
            }
            if (this.tireContract.winterSeasonInfo) {         
              this.tireContract.winterSeasonInfo.id = undefined;   
              if (this.tireContract.winterSeasonInfo.tires) {
                this.tireContract.winterSeasonInfo.tires.forEach((tire) => {
                  tire.id = undefined;
                  tire.groove = undefined;
                  tire.fileScratch = [];
                });
              }            
            }
          } else {
            this.isReNew = false;
            this.isEdit = true;
            this.tireContract = res.data.data;

            // add fileScratch
            if(this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires) {
              this.tireContract.summerSeasonInfo.tires.forEach((tire) => {
                tire.fileScratch = [];
              });
            }
            // add fileScratch
            if(this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires) {
              this.tireContract.winterSeasonInfo.tires.forEach((tire) => {
                tire.fileScratch = [];
              });
            }
          }
          if (this.isReNew || this.isSwitch) {
            this.tireContract.columnLocation = null;
            this.tireContract.rowLocation = null;
            this.tireContract.rackLocation = null;
            this.tireContract.separateControlNumber = null;
            this.tireContract.memo = null;
          }
          return true;
        }
        return false;
      });
  }

  private loadComponent(data: DataBus) {
    if (data.event === 'info') {
      this.loadTireInfoComponent();
    } else if (data.event === 'image') {
      this.loadTireImageComponent();
    } else if (data.event === 'image_edit') {
      if(data.data && data.data.isGoBack ) {
        if (this.tireContract.summerSeasonInfo && this.tireContract.summerSeasonInfo.tires) {
          this.tireContract.summerSeasonInfo.tires.forEach(tire => {
              tire.imageScratch = [];
          });
        }
        if (this.tireContract.winterSeasonInfo && this.tireContract.winterSeasonInfo.tires) {
          this.tireContract.winterSeasonInfo.tires.forEach(tire => {
              tire.imageScratch = [];
          });
        }
      }
      this.loadTireImageEditComponent();
    } else if (data.event === 'confirm_info') {
      this.loadTireConfirmInfoComponent();
    } else if (data.event === 'confirm_term') {
      this.loadTireConfirmTermComponent();
    } else if (data.event === 'save') {
      this.saveContract(data.data);
    } else if (data.event === 'save_and_regiter') {
      this.storeContractAndRegister();    
    } else if (data.event === 'cancel_edit') {
      this.goToDetail();
    } else if (data.event === 'save_edit') {
      this.updateContract();
    } else if (data.event === 'cancel_register') {
      this.showCancelRegister();
    } else if (data.event === 'home') {
      this.goToHome();
    }
  }

  private loadTireInfoComponent() {
    this.showTireInfoComponent = true;
    this.showTireImageComponent = false;
    this.showTireImageEditComponent = false;
    this.showTireConfirmInfoComponent = false;
    this.showTireConfirmTermComponent = false;
  }

  private loadTireImageComponent() {
    this.showTireInfoComponent = false;
    this.showTireImageComponent = true;
    this.showTireImageEditComponent = false;
    this.showTireConfirmInfoComponent = false;
    this.showTireConfirmTermComponent = false;
  }

  private loadTireImageEditComponent() {
    this.showTireInfoComponent = false;
    this.showTireImageComponent = false;
    this.showTireImageEditComponent = true;
    this.showTireConfirmInfoComponent = false;
    this.showTireConfirmTermComponent = false;
  }

  private loadTireConfirmInfoComponent(isConfirmMode: boolean = false) {
    this.isConfirmMode = isConfirmMode;
    this.showTireInfoComponent = false;
    this.showTireImageComponent = false;
    this.showTireImageEditComponent = false;
    this.showTireConfirmInfoComponent = true;
    this.showTireConfirmTermComponent = false;
  }

  private loadTireConfirmTermComponent() {
    this.showTireInfoComponent = false;
    this.showTireImageComponent = false;
    this.showTireImageEditComponent = false;
    this.showTireConfirmInfoComponent = false;
    this.showTireConfirmTermComponent = true;
  }

  private storeContractAndRegister() {
    this.tireContractList.push(this.tireContract);
    this.tireContract = new TireStoringContract({
      customer: this.currentCustomer,
      status: 0,
      period: this.tireContract.period,
      tireType: null,
      summerSeasonInfo: new TireStoringContractSeasonInfo({
        tireType: TireTypeEnum.SUMMER,
        tires: [
          new TireStoringInfo({ no: 1, type: TireTypeEnum.SUMMER }),
          new TireStoringInfo({ no: 2, type: TireTypeEnum.SUMMER }),
          new TireStoringInfo({ no: 3, type: TireTypeEnum.SUMMER }),
          new TireStoringInfo({ no: 4, type: TireTypeEnum.SUMMER })
        ],
      }),
      winterSeasonInfo: new TireStoringContractSeasonInfo({
        tireType: TireTypeEnum.WINTER,
        tires: [
          new TireStoringInfo({ no: 1, type: TireTypeEnum.WINTER }),
          new TireStoringInfo({ no: 2, type: TireTypeEnum.WINTER }),
          new TireStoringInfo({ no: 3, type: TireTypeEnum.WINTER }),
          new TireStoringInfo({ no: 4, type: TireTypeEnum.WINTER })
        ],
      }),
    });
    this.loadTireInfoComponent();
  }

  private saveContract(isSendEmail: boolean) {
    if (this.tireContractList && this.tireContractList.length > 0) {
      this.isLoading = true;
      this.tireContractList.forEach((contract) => contract.signatureImageBase64 = this.tireContract.signatureImageBase64);
      let contractList = this.tireContractList;
      contractList.push(this.tireContract);
      tireStoringContractService.createMultiContract(contractList, isSendEmail)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            this.tireContractList = res.data.data;
            res.data.data.forEach((contract) => toastService.success(this.$t('view.tire_register.message.contract_created').toString() + contract.slipNo));
            this.showRegistrationCompletedModal = true;
          }
        })
        .finally(() => this.isLoading = false);
    } else {
      const reNewParam = Utils.getQueryParam(this.$route.query.reNew);
      const switchParam = Utils.getQueryParam(this.$route.query.switchTire);
      if (reNewParam === 'true') {
        this.isLoading = true;
        tireStoringContractService.create(this.tireContract, isSendEmail, this.tireContract.id)
          .then((res) => {
            if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
              this.tireContract = res.data.data;
              toastService.success(this.$t('view.tire_register.message.contract_created').toString() + res.data.data.slipNo);
              this.showRegistrationCompletedModal = true;
            }
          })
          .finally(() => this.isLoading = false);
      } else if (switchParam === 'true') {
        this.isLoading = true;
        tireStoringContractService.update(this.tireContract, true)
          .then((res) => {
            if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data && res.data.data.id) {
              this.tireContract = res.data.data;
              toastService.success(this.$t('view.tire_register.message.contract_updated').toString() + res.data.data.slipNo);   
              tireStoringContractService.exportContract(res.data.data.id)
                .finally(() => {
                  this.goToDetail();  
                });
            }
          })
          .finally(() => this.isLoading = false);
      } else {
        this.isLoading = true;
        tireStoringContractService.create(this.tireContract, isSendEmail)
          .then((res) => {
            if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
              this.tireContract = res.data.data;

              if(this.tireContract.summerSeasonInfo){
                this.tireContract.summerSeasonInfo.tires.forEach(item => {
                  item.imageScratchUrl = [];
                })
              }
              if(this.tireContract.winterSeasonInfo){
                this.tireContract.winterSeasonInfo.tires.forEach(item => {
                  item.imageScratchUrl = [];
                })
              }
              toastService.success(this.$t('view.tire_register.message.contract_created').toString() + res.data.data.slipNo);
              this.showRegistrationCompletedModal = true;
            }
          })
          .finally(() => this.isLoading = false);
      }     
    }
  }

  private updateContract() {
    if (!this.tireContract.id) {
      return;
    }
    this.isLoading = true;
    tireStoringContractService.update(this.tireContract, this.isSwitch)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          const switchTire = Utils.getQueryParam(this.$route.query.switchTire);
          if (switchTire === 'true') {
            this.showSwitchTireDialog = true;
          } else {    
            toastService.success(this.$t('view.tire_register.message.contract_updated').toString() + res.data.data.slipNo);         
            this.goToDetail();  
          }  
        }
      })
      .finally(() => this.isLoading = false);
  }

  private goToDetail() {
    if (this.tireContract.id) {
      const callbackUrl = Utils.getQueryParam(this.$route.query.callbackUrl);
      let newContract = Utils.getQueryParam(this.$route.query.newContract);
      if(newContract === 'true') {
        window.location.href = process.env.VUE_APP_ROOT_API + '/admin/contracts/list';
      }else if (callbackUrl) {
        window.location.href = callbackUrl;
      } else {
        this.$router.push({
          name: 'routes.tire_contract_detail',
          params: {
            id: this.tireContract.id,
          },
        });
      }          
    }   
  }

  private goToHome() {
    const callbackUrl = Utils.getQueryParam(this.$route.query.callbackUrl);
    if (callbackUrl) {
      window.location.href = callbackUrl;
    } else {
      this.$router.push({ name: 'routes.home' });
    }   
  }

  private showCancelRegister() {
    if (this.tireContractList && this.tireContractList.length > 0) {
      this.showCancelRegisterMultiDialog = true;
    } else {
      this.showCancelRegisterDialog = true;
    }
  }

  private async exportContract() {
    if (this.tireContractList && this.tireContractList.length > 0) {
      this.isLoading = true;
      this.$router.push({name: 'routes.home'});
      // Export multiple contract
      const contractIds: any[] = this.tireContractList
        .map((contract) => contract.id);           
      tireStoringContractService.exportMultiContract(contractIds)
        .then(() => {
          // Back to T103 in confirm mode
          this.loadTireConfirmInfoComponent(true);
        })
        .finally(() => this.isLoading = false);
    } else {
      // Export 1 contract
      if (!this.tireContract.id) {
        return;
      }
      this.isLoading = true;
      await tireStoringContractService.exportContract(this.tireContract.id)
        .then(() => {
          // Back to T103 in confirm mode
          this.loadTireConfirmInfoComponent(true);
        })
        .finally(() => {
          this.isLoading = false;
        });
      this.goToDetail();     
    }
    // // Print file
    // printJS(tireStoringContractService.getContractUrl(this.tireContract.id));
    // // Back to T103 in confirm mode
    // this.loadTireConfirmInfoComponent(true);
  }

  private cancelRegisterSingle() {
    // Xóa thông tin của khách hàng đã đăng ký trong DB, clear thông tin lốp đã nhập rồi chuyển đến màn T001-Top
    if (!this.currentCustomer.id) {
      return;
    }
    customerService.delete(this.currentCustomer.id)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
          toastService.successMessage('view.tire_register.message.customer_deleted');         
          this.$router.push({ name: 'routes.home' });
        }
      });
  }

  private cancelRegisterMulti() {
    // Clear thông tin lốp đang đăng ký rồi chuyển tới màn T103- Confirm 
    if (this.tireContractList && this.tireContractList.length > 0) {
      let lastContract = this.tireContractList.pop();
      if (lastContract) {
        this.tireContract = lastContract;
        // Back to T103
        this.loadTireConfirmInfoComponent();
      }
    }
  }

}
